import Table from './src/table.vue';
import TableHead from './src/table-head.vue';
import TableBody from './src/table-body.vue';
import TableConfig from './src/table-config.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToTable: SFCWithInstall<typeof Table> = withInstall(Table);
export const ToTableHead: SFCWithInstall<typeof TableHead> = withInstall(TableHead);
export const ToTableBody: SFCWithInstall<typeof TableBody> = withInstall(TableBody);
export const ToTableConfig: SFCWithInstall<typeof TableConfig> = withInstall(TableConfig);

export * from './src/instance';